// extracted by mini-css-extract-plugin
export default {"tracks":"Artist_tracks__UJVih","albums":"Artist_albums__L+soy"};